module.exports = __webpack_public_path__ + "img/09.6dc29950.jpg";